<template>
  <div o-Container>
    <div class="load">
      <!--<div id="holder"><canvas width="100" height="100" style="width: 100px; height: 100px;"></canvas></div>-->

<!--      提速以后，不再需要加载遮罩了-->
<!--      <div class="progress">-->
<!--        <div class="progress-bar progress-bar-info progress-bar-striped" role="progressbar" aria-valuenow="20"-->
<!--             aria-valuemin="0" aria-valuemax="100" style="width: 0%;">-->
<!--          &lt;!&ndash;<span class="sr-only">0% Complete</span>&ndash;&gt;-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <o-com-head id="div_Head" v-bind:click="systemClick">头部控件</o-com-head>
    <o-com-menu id="div_Menu" v-bind:click="menuClick">菜单控件</o-com-menu>
    <o-com-content id="div_Content" ref="com_content" v-bind:click="tabClick">内容控件</o-com-content>
<!--    <span id="div_Footer"> {{companyData}}</span>-->
    <span id="div_Footer">{{companyData.FullName}} 客服热线：{{companyData.ContactsMobile}} 服务邮箱：{{companyData.ContactsMail}} Copyright 2020-2022</span>
  </div>
</template>

<script>
  import Menu from './Menu';
  import Head from './Head';
  import Content from './Content';

  export default {
    name: "index",
    data() {
      return {
        octopus: this.$parent.octopus,
        companyData: {},
      }
    },
    created: function () {
      this.octopus.tips.debug("Home.vue执行了created事件。");
    },
    mounted: function () {
      this.octopus.tips.debug("Home.vue执行了mounted事件。");
    },
    beforeUpdate: function () {
      this.octopus.tips.debug("Home.vue执行了beforeUpdate事件。");
    },
    updated: function () {
      this.octopus.tips.debug("Home.vue执行了updated事件。");
    },
    activated: function () {
      this.loadCompanyInfo();
      this.octopus.tips.debug("Home.vue执行了activated事件。");
    },
    deactivated: function () {
      this.octopus.tips.debug("Home.vue执行了deactivated事件。");
    },
    components: {
      "o-com-menu": Menu,
      "o-com-head": Head,
      "o-com-content": Content
    },
    methods: {
      systemClick: function () {
        // Vue嵌套太深，不太能反应过来，需要刷新一下。
        // this.$refs.com_menu.refresh();
        this.octopus.tips.debug("您点击了系统：" + this.octopus.passport.system);
      },
      menuClick: function (menu) {
        this.octopus.tips.debug("您点击了菜单：" + JSON.stringify(menu));
        // data.status = 0;
        // this.$refs.com_content.set(data);
      },
      tabClick: function (tab) {
        this.octopus.tips.debug("您点击了Tab：" + JSON.stringify(tab));
      },
      testMeth: function () {
        // 调用子组件自定义中的函数
        this.$refs.lst_user.$options.diyyy();
        // 调用子组件方法中的函数
        this.$refs.lst_user.ltDetailFun();
        // 调用子组件中的data中的数据
        console.log(this.$refs.lst_user.source);
        // 调用子组件方法中的remove方法。
        this.$refs.lst_user.remove();
        // console.log(this.$refs.com_menu.menu);
        // // 更新指定数据源。
        // let tableID = 13;
        // this.octopus.request.api.get("/Octopus/Engine/Refresh/" + tableID,
        //   // 处理回调事件，通过分析data.status.code的状态来实现。
        //   function (data) {
        //     console.log("刷新八爪鱼框架，状态：" + JSON.stringify(data));
        //   });
      },
      subMeth: function () {
        this.octopus.tips.debug("Index.vue执行了 由子组件触发的父组件 事件。");
      },
      receiveChildData: function (data) {
        this.octopus.tips.debug("接收到子组件传来的数据：" + data);
      },
      loadCompanyInfo:function(){
        let o = this;
        this.octopus.request.api.post("/Octopus/Engine/Item", {
            id: 31,
            value: this.octopus.passport.authorization.company,
            type: "SELECT",
            cellData: [
              {name: "Logo"},
              {name: "Name"},
              {name: "FullName"},
              {name: "ContactsMobile"},
              {name: "ContactsMail"}
            ]
          },
          // 处理回调事件，通过分析data.status.code的状态来实现。
          function (data) {
            if (data.status.code == 200) {
              o.companyData = {};
              $(data.content.cellData).each(function (index,item) {
                o.companyData[item.name] = item.defaultValue;
              })
            } else {
              o.octopus.tips.error(data);
            }

            // o.companyData = o.companyData;
            // o.$set(o.demo, "data", o.companyData);
            // alert(JSON.stringify(o.companyData));
            // o.companyData = 333;

          });
      },
    },
  }
</script>

<style scoped>
  /*以下配置为初始化配置，否则会有0.1秒暴露控件*/
  .load {
    width: 100%;
    height: 100%;
    background: #f7f7f7;
    position: absolute;
    z-index: 77;
  }

  .load .progress {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/Platform/Home/Page.vue